// Global runtime flags. Flip PUBLIC=true only when access is genuinely open.
// Every visible "Preview / Read from chain" line reads from PUBLIC.
export const PUBLIC = false;

export const CHAIN_ID = 4663;
export const CHAIN_HEX = "0x" + CHAIN_ID.toString(16);
export const DOMAIN = "navearn.xyz";
